import { useRef, useCallback } from 'react'
import { motion } from 'framer-motion'
import { useLocalStorage } from 'react-use'
import { MenuDrawerButton } from './menu-drawer-button'

export const PageWithNav = ({ children }) => {
  return <div className="page-with-nav flex items-stretch">{children}</div>
}

const Nav = ({ children }) => {
  const [value, setValue, _remove] = useLocalStorage('clvn-navigation-is-expanded', true)
  const navRef = useRef<HTMLElement>(null)
  const getMenuExpandedStatus = useCallback(() => {
    if (!navRef.current) return value ?? false // Initial load, default to local storage value.
    return navRef.current?.getAttribute('aria-expanded') === 'true'
  }, [value])

  const toggleNavExpansion = useCallback(
    function toggleNavExpansion() {
      if (!navRef.current) return

      const isExpanded = getMenuExpandedStatus()
      const nextStatus = !isExpanded
      navRef.current.setAttribute('aria-expanded', String(nextStatus))
      navRef.current.focus()

      // Save user preference into local storage.
      setValue(nextStatus)
    },
    [getMenuExpandedStatus],
  )

  return (
    <motion.nav
      id="page-with-nav-drawer"
      ref={navRef}
      aria-expanded={value}
      className="peer page-with-nav__drawer relative flex aria-expanded:w-[240px] w-[65px] transition-all ease-[cubic-bezier(0.65, 0.05, 0.36, 1)] duration-300"
    >
      {children({ toggle: toggleNavExpansion, getMenuExpandedStatus })}
      <div className="flex w-[5px] bg-cv-blue-500">
        <MenuDrawerButton
          onClick={toggleNavExpansion}
          getMenuExpandedStatus={getMenuExpandedStatus}
        />
      </div>
    </motion.nav>
  )
}

const Page = ({ children }) => {
  return (
    <div className="page-with-nav-drawer__main relative flex flex-col flex-1 grow w-[calc(100%-65px)] peer-[[aria-expanded=true]]:w-[calc(100%-240px)]">
      {children}
    </div>
  )
}

PageWithNav.Nav = Nav
PageWithNav.Page = Page
PageWithNav.MenuDrawerButton = MenuDrawerButton
